/**
 * 日期格式化
 */

import dateFormat from "dateformat";
import { i18n } from "dateformat";

i18n.dayNames = [
  "周日",
  "周一",
  "周二",
  "周三",
  "周四",
  "周五",
  "周六",
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
];

export default dateFormat;
